import ProjectsPage from 'pages/ProjectsPage';

const ProjectsIndexRoute = () => <ProjectsPage />;

export default ProjectsIndexRoute;
